/* MINT details */

export const MINT_ACCOUNT_ID = 3315;
export const MINT_ACCOUNT_EMPLOYEE_TYPE_FIELD_ID = 3677;
export const MINT_ACCOUNT_EMPLOYEE_TYPE_TEMP_ID = 14425;

/* compass demo details */
export const COMPASS_DEMO_ACCOUNT_ID = 6673;
export const COMPASS_DEMO_ACCOUNT_NI_NUMBER_ID = 4642;
export const COMPASS_DEMO_ACCOUNT_AKA_ID = 8654;
export const COMPASS_DEMO_ACCOUNT_SECONDARY_ADDRESS_ID = 8811;

/* employee fields details */
export const EMPLOYEE_FIELD_IDENTIFICATION_ID = 31;
export const EMPLOYEE_FIELD_EMPLOYMENT_START_DATE = 2;
export const NICKNAME_FIELD_ID = 52908;

/* Legends Madrid */
// "Contracted base rate" employee custom field — prices the Madrid payroll, so it is
// required on the employee card for the Madrid account.
export const MADRID_LEGENDS_CONTRACTED_BASE_RATE_FIELD_ID = 98570;

/* 647 */
export const ISRAEL_647_ACCOUNT_ID = 12720;

export const TERMINATION_DATE_FIELD = 'end-employment-date';

export const MAX_FIRST_LAST_NAME_LENGTH = 50;
